import React from "react";
import { Box, Typography, Button, Tooltip, Chip, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";
import { useTheme } from "@mui/material";

const SystemsHeader = ({
  showArchivedSystems,
  setShowArchivedSystems,
  archivingSystemId,
  hasActiveFilters,
  activeFiltersCount,
  onAddSystem,
}) => {
  const theme = useTheme();

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
      <Typography
        variant="h5"
        fontWeight="600"
        color={theme.customColors.text.strong}
      >
        Systems
      </Typography>
      <ToggleButtonGroup
        value={showArchivedSystems ? 'archived' : 'active'}
        exclusive
        onChange={(e, newValue) => {
          if (newValue !== null) {
            setShowArchivedSystems(newValue === 'archived');
          }
        }}
        disabled={archivingSystemId !== null}
        aria-label="system status filter"
        size="small"
        sx={{
          borderRadius: '26px',
          border: '1px solid #E8EAED',
          gap: 0.2,
          overflow: 'hidden',
          '& .MuiToggleButton-root': {
            border: 'none !important',
            borderRadius: '36px',
            color: '#6B7280',
            textTransform: 'none',
            fontWeight: 600,
            fontSize: '0.75rem',
            px: 3,
            py: 1,
            minWidth: '70px',
            transition: 'all 0.2s ease-in-out',
            '&.Mui-selected': {
              backgroundColor: '#3B82F6',
              color: '#fff',
              '&:hover': {
                backgroundColor: '#2563EB',
              },
            },
            '&:hover:not(.Mui-selected)': {
              backgroundColor: '#F9FAFB',
              color: '#374151',
            },
            '&:not(:first-of-type)': {
              borderLeft: '1px solid #E5E7EB',
            },
          },
          '&.Mui-disabled': {
            opacity: 0.6,
            cursor: 'not-allowed',
          },
        }}
      >
        <ToggleButton value="active">Active</ToggleButton>
        <ToggleButton value="archived">Archived</ToggleButton>
      </ToggleButtonGroup>
      {hasActiveFilters && (
        <Chip
          label={`${activeFiltersCount} filter${activeFiltersCount !== 1 ? 's' : ''} active`}
          size="small"
          color="primary"
          variant="outlined"
          sx={{
            height: 24,
            fontSize: "0.75rem",
            fontWeight: 500,
            color: theme.customColors.text.secondary,
            borderColor: theme.customColors.border.main,
            background: theme.customColors.background.light,
          }}
        />
      )}
      <Box sx={{ flex: 1 }} />
      <Tooltip title="Add a new system" arrow>
        <span>
          <Button
            variant="contained"
            startIcon={<AddIcon sx={{ fontSize: 16 }} />}
            onClick={onAddSystem}
            sx={{
              bgcolor: "#3B82F6",
              color: "#fff",
              fontWeight: 500,
              borderRadius: "8px",
              textTransform: "none",
              fontSize: "14px",
              px: 2,
              py: 1,
              "&:hover": { bgcolor: "#2563EB" },
              "&:disabled": {
                bgcolor: theme.customColors.background.light,
                color: theme.customColors.text.disabled,
              },
            }}
          >
            Add New Account
          </Button>
        </span>
      </Tooltip>
    </Box>
  );
};

export default SystemsHeader;

